import { logEvent } from 'firebase/analytics';
import { getAnalyticsInstance } from './firebaseConfig';

/**
 * Log authentication events to Firebase Analytics
 * Free tier: Unlimited events, automatically aggregated in Firebase Console
 */
export const logAuthEvent = (eventName, params = {}) => {
  try {
    const analytics = getAnalyticsInstance();
    if (analytics) {
      logEvent(analytics, eventName, {
        timestamp: new Date().toISOString(),
        ...params
      });
      console.log(`📊 Analytics: ${eventName}`, params);
    }
  } catch (error) {
    // Fail silently - don't break user experience for analytics
    console.warn('Analytics logging failed:', error);
  }
};

/**
 * Log Google Sign-In attempt
 */
export const logGoogleSignInAttempt = (page = 'unknown') => {
  logAuthEvent('google_signin_attempt', { page });
};

/**
 * Log Google Sign-In success
 */
export const logGoogleSignInSuccess = (userId, email, page = 'unknown') => {
  logAuthEvent('google_signin_success', { 
    page,
    user_id: userId,
    method: 'google',
    // Don't log full email for privacy - just domain
    email_domain: email?.split('@')[1] || 'unknown'
  });
};

/**
 * Log Google Sign-In error
 */
export const logGoogleSignInError = (errorCode, errorMessage, page = 'unknown') => {
  logAuthEvent('google_signin_error', { 
    page,
    error_code: errorCode,
    error_message: errorMessage,
    method: 'google'
  });
};

/**
 * Log Email Sign-In attempt
 */
export const logEmailSignInAttempt = (page = 'unknown') => {
  logAuthEvent('email_signin_attempt', { page });
};

/**
 * Log Email Sign-In success
 */
export const logEmailSignInSuccess = (userId, emailDomain, page = 'unknown') => {
  logAuthEvent('email_signin_success', { 
    page,
    user_id: userId,
    method: 'email',
    email_domain: emailDomain
  });
};

/**
 * Log Email Sign-In error
 */
export const logEmailSignInError = (errorCode, errorMessage, page = 'unknown') => {
  logAuthEvent('email_signin_error', { 
    page,
    error_code: errorCode,
    error_message: errorMessage,
    method: 'email'
  });
};
